import React from "react";
import { DocumentsPreuvesSecuritePanel } from "@/components/authority/KarateAuthorityDocumentsPanels.jsx";
import { SecureBackendBlueprintPanel } from "@/components/authority/KarateDocumentImportPanels.jsx";

export function DocumentsPreuvesSecuritePage() {
  return (
    <div data-testid="page-admin-documents-preuves-securite">
      <DocumentsPreuvesSecuritePanel />
      <SecureBackendBlueprintPanel />
    </div>
  );
}
